import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectMeasureGraphicStateService} from '../../../../shared/services/project-measure-graphic-state/project-measure-graphic-state.service';
import {merge, Subscription} from 'rxjs';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {TranslateService} from '@ngx-translate/core';
import {ActiveToast, ToastrService} from 'ngx-toastr';

@Component({
  selector: 'app-smart-offsets-mode',
  templateUrl: './smart-offsets-mode.component.html'
})
export class SmartOffsetsModeComponent implements OnInit, OnDestroy {

  isDisabled: boolean;
  isChecked: boolean;
  stateInfo: string;
  stateSubscription: Subscription;
  activeToastr: ActiveToast<any>;

  constructor(private state: ProjectMeasureGraphicStateService,
              private translateService: TranslateService,
              private toastr: ToastrService) {
  }

  ngOnInit() {
    this.isDisabled = this.state.isSmartOffsetModeDisabled$.getValue().smartOffsetModeIsDisabled;
    this.stateSubscription = merge(
      this.state.isSmartOffsetModeDisabled$,
      this.state.isSmartOffsetModeChecked$
    ).subscribe(
      (state) => {
        if (Object.keys(state).length === 0) {   // hack to be fixed (to get rid of seed value of behaviour subject)
          return;
        }
        this.isDisabled = state.smartOffsetModeIsDisabled;
        this.isChecked = state.smartOffsetModeIsChecked;
        this.stateInfo = state.smartOffsetStateInfo || 'SMART_OFFSET_MODE';
        if (state.switchSmartOffsetsNotification) {
          this.closeSmartOffsetNotification();
          if ('open' === state.switchSmartOffsetsNotification) {
            this.openSmartOffsetNotification();
          }
        }
      }
    );
  }

  ngOnDestroy() {
    if (this.stateSubscription) {
      this.stateSubscription.unsubscribe();
    }
    this.closeSmartOffsetNotification();
  }

  switchSmartOffsetsMode(toggleChange: MatSlideToggleChange) {
    this.state.updateState({smartOffsetModeIsChecked: toggleChange.checked});
  }

  private openSmartOffsetNotification() {
    const c1 = this.translateService.instant('TIME_RANGE_MUST_BE_LESS_THAN_24H_LESS_POINTS');
    const message = `<ul>
                            <li>${c1}</li>
                            <li>${this.translateService.instant('DYNAMICS_MUST_BE_TURNED_OFF')}</li>
                            <li>${this.translateService.instant('OFFSETS_MUST_BE_VISIBLE')}</li>
                            <li>${this.translateService.instant('UNDERSAMPLING_MUST_BE_FAST')}</li>
                            <li>${this.translateService.instant('DATA_GROUPING_MUST_BE_NONE')}</li>
                           </ul>`;
    this.activeToastr = this.toastr.info(message, this.translateService.instant('SMART_OFFSET_MODE_ACTIVE'),
      {disableTimeOut: true, closeButton: true, enableHtml: true});
  }

  private closeSmartOffsetNotification() {
    if (this.activeToastr) {
      this.toastr.clear(this.activeToastr.toastId);
    }
  }
}
